import BaseTooltipWrapper from "@/components/BaseWrappers/BaseTooltipWrapper";
import FormErrorMessage from "@/components/FormErrorMessage/FormErrorMessage";
import SelectInput from "@/components/SelectInput/SelectInput";
import React, { useState } from "react";
import { AiOutlineInfoCircle as InfoIcon } from "@react-icons/all-files/ai/AiOutlineInfoCircle";
import { createChallengeTooltipsText } from "@/features/challenge/utils/CreateChallengeTooltips";
import { Flex, Heading, Select, Text } from "@radix-ui/themes";
import { InfoCircledIcon } from "@radix-ui/react-icons";
export const CreateChallengeSelectMenu: React.FunctionComponent<{
  name: string;
  label: string;
  value: string;
  setFieldValue: any;
  errors: any;
  placeholder: string;
  options: any;
  isEdit: boolean;
  hasTooltip?: boolean;
  toolTipToShow?: string;
}> = ({
  name,
  label,
  value,
  setFieldValue,
  errors,
  placeholder,
  options,
  isEdit,
  hasTooltip,
  toolTipToShow,
}) => {
  const [dataId, setDataId] = useState<any>();
  return (
    <Flex gap="3" direction="column">
      <Flex gap="2" direction="column">
        {hasTooltip && toolTipToShow && (
          <BaseTooltipWrapper
            overlayTrigger={
              <Flex align="center" gap="1">
                <Heading as="h3" size="4">
                  {label}
                  {isEdit && (
                    <Text size="1" color="gray">
                      ( cannot be edited )
                    </Text>
                  )}
                </Heading>
                <InfoCircledIcon />
              </Flex>
            }
            tooltipContent={createChallengeTooltipsText?.[toolTipToShow]}
          />
        )}

        <SelectInput
          name={name}
          value={value}
          styleProps={`base-input`}
          placeholder={placeholder}
          options={options}
          hasUploading={false}
          children={undefined}
          isDisabled={isEdit}
          setDataId={setDataId}
        />
        {errors && errors[name] && (
          <FormErrorMessage
            isVisible={!!errors[name]}
            text={errors[name] as string}
          />
        )}
      </Flex>
    </Flex>
  );
};
